import onboardingService from "@irati/onboarding/services/onboarding";
import OnboardingSteps from "@irati/onboarding/enums/Step";
var CategoriesService = /** @class */ (function () {
    function CategoriesService() {
        this.shouldShowCategoriesBanner = function (user, options) {
            if (options === void 0) { options = {}; }
            var userId = user.uuid;
            return onboardingService.get(userId, options).then(function (_a) {
                var completedSteps = _a.completedSteps;
                return !completedSteps.includes(OnboardingSteps.HAS_DISMISSED_CUSTOM_CATEGORIES_BANNER);
            });
        };
        this.dismissCategoriesBanner = function (user) {
            onboardingService.completeStep(user, OnboardingSteps.HAS_DISMISSED_CUSTOM_CATEGORIES_BANNER);
        };
    }
    return CategoriesService;
}());
export default new CategoriesService();
